import { type ReportsState } from "./state";

export const initialState: ReportsState = {
  queue: [],
  isPending: false,
  isRejected: false,
  errorMessage: "",
  isResolving: false,
  resolveError: "",
};
